import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Form } from "@formio/react";
import { Button, Flex, Space } from 'antd';
import "formiojs/dist/formio.full.min.css";
import _ from 'lodash-es';
import { useRef, useState, useEffect } from "react";
import intl from 'react-intl-universal';

import request from "../../../libs/request";
import { isBase64Url, uploadFile } from "../../../libs/FileHelper";
import Evisit from '../../../libs/Evisit';

const getConsultation = (room) => {
    // Try to get first consultation of room
    var result = null;
    var consultations = _.get(room, 'payment.consultations', []);
    var visibleConsultations = _.filter(consultations, function(consultation) {
        return consultation.visible_to_patient !== false;
    });
    if (visibleConsultations.length) {
        result = visibleConsultations[0];
    } else if(consultations.length) {
        result = consultations[0];
    }
    return result;
}


const Intake = ({currentComponent, onNext, onPrevious, data, isMobileWebview}) => {
    const componentKey = "intake";
    const [formIOComponents, setFormIOComponents] = useState({components: []});
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        const components = _.get(currentComponent, "input.form.components", []);
        if (components) {
            setFormIOComponents({components: components});
        }
    }, [currentComponent]);
    
    const submitData = async (submission) => {
        setLoading(true);

        var value = submission.data;
        var room = _.get(data, "room.value", {});
        const ssoFields = ['first_name', 'last_name', 'type', 'login'];

        // Check guest creation flow
        if (value.first_name && value.first_name.length > 0) {
            var defaultData = {
                first_name: 'Guest User',
                last_name: ' ',
                type: 600
            };
            var ssoData = _.assign(defaultData, value);
            const res = await request.post(`${window.base_url}/api_v3/users/sso`, _.pick(ssoData, ssoFields));
            Evisit.postMessageBackToParent({
                name: "user.created",
                data: res["data"]
            });
            window.user = _.get(res, 'data', {});
            if (_.has(res, 'data.token.token')) {
                window.user.token = res['data']['token']['token']
            }
        }

        // Create and update intake
        var defaultIntakeData = {
            location: '--'
        };
        var intakeData = _.assign(defaultIntakeData, value);
        var files = [];
        if (intakeData['attachments']) {
            for (var i in intakeData['attachments']) {
                var file = intakeData['attachments'][i];
                if (isBase64Url(file.url)) {
                    const resp = await uploadFile(file.url, file.name);
                    if (resp.id) {
                        files.push(resp.id)
                    }
                }
            }
            intakeData['attachments'] = files.join()
        }

        if (!_.has(data, "intake.value.consultation")) {
            var consultation = getConsultation(room);
            if (consultation) {
                intakeData["consultation"] = consultation;
                intakeData["paymentCurrency"] = "USD"
            }
        }
        intakeData["room_code"] = room["code"];

        if (_.has(data, "specialty.value.specialty")) {
            intakeData["specialtyId"] = _.get(data, "specialty.value.specialty", "")
        }

        var intake_id = _.get(data, "intake.value.id");
        intake_id = intake_id ? "/" + intake_id : "";
        const response = await request.post(`${window.base_url}/api_v3/intakes${intake_id}`, intakeData);
        setLoading(false);
        onNext(_.get(response, "data", null));
    }

    const onSubmit = (submission) => {
        Evisit.executeActions("submit", currentComponent, {data: submission}, data).then(response => {
            submitData(response);
        });
    }

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Form
                form={formIOComponents}
                onSubmit={(submission) => onSubmit(submission)}
                formReady={(formInstance) => {
                    formRef.current = formInstance;
                    formInstance.submission = {
                        data: _.get(data, `${componentKey}.value`, {})
                    };
                }}
                options={{
                    noAlerts: true,
                }}
            />
            <Flex justify={isMobileWebview ? "center" : "space-between"}>
                { (onPrevious != null && !isMobileWebview) ?
                    <Button onClick={onPrevious}>
                        <LeftOutlined style={{verticalAlign:"middle"}} />
                        {intl.get("back").d("Back")}
                    </Button> : <div></div>
                }
                <Button
                    type="primary"
                    loading={loading}
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    onClick={() => {
                        formRef.current.submit();
                    }
                }>
                    {intl.get("continue").d("Continue")}
                    <RightOutlined style={{verticalAlign:"middle"}} />
                </Button>
            </Flex>
        </Space>
    );
}

export default Intake;